export enum PsyToolsId {
  EMOTIONS = 1,
  DPDG = 2,
  MAC_CARDS = 3,
  QUESTION = 4,
  WHEEL = 5,
  COLOR_CODE = 6,
  CLOUDS = 7,
  GROW = 8,
  SAND_THERAPY = 9,
}

type TToolsName =
  | 'not_implemented'
  | 'emotions_detection'
  | 'dpdg'
  | 'metaforic_cards'
  | 'new_question'
  | 'life_balance_wheel'
  | 'color_code'
  | 'clouds'
  | 'grow_ai'
  | 'sand_therapy';

export const toolNamesMap: Record<PsyToolsId | 0, TToolsName> = {
  [0]: 'not_implemented',
  [PsyToolsId.EMOTIONS]: 'emotions_detection',
  [PsyToolsId.DPDG]: 'dpdg',
  [PsyToolsId.MAC_CARDS]: 'metaforic_cards',
  [PsyToolsId.QUESTION]: 'new_question',
  [PsyToolsId.WHEEL]: 'life_balance_wheel',
  [PsyToolsId.COLOR_CODE]: 'color_code',
  [PsyToolsId.CLOUDS]: 'clouds',
  [PsyToolsId.GROW]: 'grow_ai',
  [PsyToolsId.SAND_THERAPY]: 'sand_therapy',
};
